export class FindingExclusionValueFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "contains",
            "baseName": "contains",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionValueFilters.attributeTypeMap;
    }
    constructor() {
    }
}
